import { IHttpService } from "../HttpService";
import ReportingType, {
  IReportingType,
  TReportingType
} from "../../model/reporting/ReportingType";
import * as Constants from "../../common/Constants";
import { formatBooleanValue, parseBooleanValue } from "../..";
import { DateService } from "../DateService";

export interface IReportingTypeService {
  getReportingTypes(): Promise<IReportingType[]>;
  createReportingType(reportingType: IReportingType): Promise<any>;
  updateReportingType(reportingType: IReportingType);
}

const ReportingTypeService = (httpService): IReportingTypeService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/codebooks";
  const _reportingTypesPath = "reporting-types";

  let ReportingTypeListMapper = (json = []) => {
    return json.map((item: any) => {
      let reportingType = ReportingType(item);
      reportingType.valid = formatBooleanValue(item.valid);
      reportingType.repeatingPeriod = formatBooleanValue(item.repeatingPeriod);
      return reportingType;
    });
  };

  let parseTimeMeasureUnits = periodOfRepetitonMeasureUnit => {
    if (
      periodOfRepetitonMeasureUnit ===
      Constants.ReportingTypePeriodMeasureUnitConstants.DAY
    )
      return Constants.ReportingTypePeriodMeasureUnitConstants.DAY;
    else if (
      periodOfRepetitonMeasureUnit ===
      Constants.ReportingTypePeriodMeasureUnitConstants.MONTH
    )
      return Constants.ReportingTypePeriodMeasureUnitConstants.MONTH;
    else return Constants.ReportingTypePeriodMeasureUnitConstants.YEAR;
  };

  const parseDateToTimestamp = (date?: Date) => {
    if (date) {
      return DateService().parseDateToTimestamp(date);
    }
  };

  let ParamsMapper = (reportingType: TReportingType) => {
    return {
      code: reportingType.code,
      formTypesGroupCategoryCode: reportingType.formTypesGroupCategoryCode,
      name: reportingType.name,
      valid: parseBooleanValue(reportingType.valid),
      description: reportingType.description,
      period: reportingType.period,
      periodMeasureUnit: reportingType.periodMeasureUnit,
      repeatingPeriod: parseBooleanValue(reportingType.repeatingPeriod),
      periodOfRepetiton: reportingType.periodOfRepetiton,
      periodOfRepetitonMeasureUnit: parseTimeMeasureUnits(
        reportingType.periodOfRepetitonMeasureUnit
      ),
      dateFrom: parseDateToTimestamp(reportingType.dateFrom),
      dateTo: parseDateToTimestamp(reportingType.dateTo),
      tag: reportingType.tag,
      gracePeriodInDays: reportingType.gracePeriodInDays,
      npPeriodFrom: parseDateToTimestamp(reportingType.npPeriodFrom),
      npPeriodTo: parseDateToTimestamp(reportingType.npPeriodTo)
    };
  };

  return {
    async getReportingTypes() {
      const path = _http.buildPath(_baseUrl, _reportingTypesPath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return ReportingTypeListMapper(responseJSON);
    },

    async createReportingType(reportingType: IReportingType) {
      const path = _http.buildPath(_baseUrl, _reportingTypesPath);
      const response = await _http.post(path, {
        params: ParamsMapper(reportingType)
      });
      return _http.toText(response);
    },

    async updateReportingType(reportingType: IReportingType) {
      const path = _http.buildPath(
        _baseUrl,
        _reportingTypesPath,
        reportingType.code
      );
      const response = await _http.put(path, {
        params: ParamsMapper(reportingType)
      });
      return _http.toText(response);
    }
  };
};

export default ReportingTypeService;
